//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../Mechatronics/Mechatronics.ZoneBuilder.js";
import "../no/SelectNXObject.js";
import "../Mechatronics/Mechatronics.GripperFingerBuilderList.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"ActionDuration",0,"Expression",0],[0,"AlignCSYS",1,"CoordinateSystem",0],[1,"BaseBody",0,"SelectNXObjectList",0],[0,"Category",1,0],[1,"DectectionSensor",0,"Mechatronics.ZoneBuilder",0],[0,"EnableAlignment",1,0],[1,"FingerCollision",0,"SelectNXObject",0],[1,"FingerList",0,"Mechatronics.GripperFingerBuilderList",0],[0,"FingerType",1,0],[1,"InitPosition",0,"Expression",0],[1,"MaxPosition",0,"Expression",0],[0,"Name",1,0],[1,"Speed",0,"Expression",0],[0,"StopOnCollision",1,0],[0,"Type",1,0]],[],[]];
SPLM.Mechatronics.GripperBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.GripperBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.GripperBuilder.Types = Object.freeze({
    "Fixture" : "Fixture", "Vacuum" : "Vacuum"});

SPLM.Mechatronics.GripperBuilder.FingeTypes = Object.freeze({
    "Linear" : "Linear", "Rotary" : "Rotary"});

export default SPLM;